<template>
    <div id="myinfo-employer">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="employerName"
          name          ="employerName"
          type          ="text"
          class         =""
          placeholder   =""
          :value        ="employerName"
          @input        = "setInputValue($event.target)"
          :label        ="$t('regis-name-employer')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
          :clear-button= "!isDisabled"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'employerName'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setEmployerName',
        'validateInput'
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>